/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq2q1Inputs */

const zh_pricing_faq2q1 = /** @type {(inputs: Pricing_Faq2q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以随时升级或降级吗？`)
};

const en_pricing_faq2q1 = /** @type {(inputs: Pricing_Faq2q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I upgrade or downgrade at any time?`)
};

const es_pricing_faq2q1 = /** @type {(inputs: Pricing_Faq2q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo actualizar o degradar en cualquier momento?`)
};

/**
* | output |
* | --- |
* | "Can I upgrade or downgrade at any time?" |
*
* @param {Pricing_Faq2q1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq2q1 = /** @type {((inputs?: Pricing_Faq2q1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq2q1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq2q1(inputs)
	if (locale === "en") return en_pricing_faq2q1(inputs)
	return es_pricing_faq2q1(inputs)
});
export { pricing_faq2q1 as "pricing_faq2Q" }